import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { IMAGES } from "@/data/images";

const imgKeys = ["security", "cloud", "network"];

export const Services = () => {
  const { t } = useLanguage();
  const items = t.home.services.items;
  return (
    <section id="services" className="relative bg-ink py-28 md:py-36 px-6 md:px-12 lg:px-20">
      <div className="mb-16 md:mb-20">
        <p className="font-mono text-brand-cyan text-xs tracking-[0.25em] mb-4" data-testid="services-eyebrow">
          {t.home.services.eyebrow}
        </p>
        <h2 className="font-syne text-4xl md:text-5xl lg:text-6xl tracking-tight text-white max-w-2xl" data-testid="services-title">
          {t.home.services.title}
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {items.map((item, i) => (
          <motion.div
            key={item.tag}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className={`group relative overflow-hidden border border-white/10 bg-white/[0.02] hover:border-brand-cyan/50 hover:-translate-y-1 transition-all duration-500 ${i === 0 ? "md:col-span-2" : ""}`}
            data-testid={`service-card-${item.tag}`}
          >
            <div className="relative h-56 overflow-hidden">
              <img
                src={IMAGES.tech[imgKeys[i]]}
                alt={item.title}
                className="h-full w-full object-cover opacity-50 group-hover:opacity-70 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink to-transparent" />
              <span className="absolute top-5 left-5 font-mono text-brand-cyan text-sm">{item.tag}</span>
            </div>
            <div className="p-7 md:p-9">
              <h3 className="font-syne text-2xl text-white mb-3 tracking-tight">{item.title}</h3>
              <p className="font-manrope text-sm text-white/55 leading-relaxed">{item.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
